(function($) {
    $(function() {
        var $relatedBooks = $('.js-related-books');

        if( $relatedBooks.length === 0 ) {
            return;
        }

        var oTop = $relatedBooks.offset().top - window.innerHeight,
            showRelatedBooks = false;

        if( !$relatedBooks.data('parameters') ) {
            relatedBooksSlider($relatedBooks.find('.related-books__container'));
            return;
        }

        $(window).on('scroll', function(e) {
            var pTop = document.documentElement.scrollTop;
            if( pTop > oTop && showRelatedBooks === false ) {
                $relatedBooks.css('visibility', 'visible');
                ajaxRelatedBooks();
                showRelatedBooks = true;
            }
        });

        function ajaxRelatedBooks() {
            var data = {
                action: 'upt_related_books',
                parameters: $relatedBooks.data('parameters')
            };

            $.ajax(universityPressThemeSettings.wordpressAjaxUrl, {
                dataType: 'html',
                method: 'POST',
                data: data,
                success: function(data) {
                    $relatedBooks.hide().html(data).fadeIn(500);
                    relatedBooksSlider($relatedBooks.find('.related-books__container'));
                },
                error: function(xhr, type, err) {
                    $relatedBooks.hide();
                }
            });
        }
    });
})(jQuery);

function relatedBooksSlider(slider) {
    if( !slider ) return;
    slider.slick({
        dots: false,
        slide: 'div.related-books__book',
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 1,
        mobileFirst: true,
        accessibility: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 3
                }
            }
        ]
    });
}
